(function(){
  var searchInput = document.getElementById('abcbread-search');
  var searchCount = document.getElementById('abcbread-search-count');
  var noResults   = document.getElementById('abcbread-no-results');

  var allCards = Array.from(document.querySelectorAll(
    '.abcbread__card, .abcbread__mold-card, .abcbread__season-card'
  ));
  var totalCount = allCards.length;

  function normalize(str){ return str.replace(/\s/g,'').toLowerCase(); }

  function doSearch(query){
    var q = normalize(query);
    var visible = 0;
    allCards.forEach(function(card){
      var nameEl = card.querySelector('.item-name') || card.querySelector('p');
      var text = nameEl ? normalize(nameEl.textContent) : '';
      var numEl = card.querySelector('.item-num');
      var num = numEl ? normalize(numEl.textContent) : '';
      var match = !q || text.indexOf(q) !== -1 || num.indexOf(q) !== -1;
      card.style.setProperty('display', match ? '' : 'none', 'important');
      if(match) visible++;
    });
    document.querySelectorAll('.abcbread__sub-section').forEach(function(sub){
      var cards = sub.querySelectorAll('.abcbread__card');
      var anyVisible = Array.from(cards).some(function(c){ return c.style.display !== 'none'; });
      sub.style.opacity = anyVisible ? '' : '0.3';
    });
    if(q){
      if(searchCount) searchCount.textContent = visible + ' 件 / ' + totalCount + ' メニュー中';
      if(noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
    } else {
      if(searchCount) searchCount.textContent = '';
      if(noResults) noResults.style.display = 'none';
    }
  }

  if(searchInput){
    searchInput.addEventListener('input', function(){ doSearch(this.value); });
    searchInput.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){ this.value = ''; doSearch(''); this.blur(); }
    });
  }

  /* プレースホルダー画像 */
  var emojis = ['🍞','🥐','🥖','🥨','🧁','🫓','🥯','🍰'];
  var ei = 0;
  function makeSVG(alt){
    var em = emojis[ei++ % emojis.length];
    var label = alt.length > 16 ? alt.slice(0,14)+'…' : alt;
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="480" height="480" viewBox="0 0 480 480">'
      +'<rect width="480" height="480" fill="#F4EFE6"/>'
      +'<circle cx="240" cy="196" r="72" fill="none" stroke="#C8A870" stroke-width="1" opacity="0.5"/>'
      +'<circle cx="240" cy="196" r="58" fill="#EDE3D4" opacity="0.8"/>'
      +'<text x="240" y="216" text-anchor="middle" dominant-baseline="middle" font-size="54">'+em+'</text>'
      +'<line x1="160" y1="300" x2="320" y2="300" stroke="#C8A870" stroke-width="1" opacity="0.5"/>'
      +'<text x="240" y="326" text-anchor="middle" font-family="Georgia,serif" font-size="15" fill="#7A5230">'+label+'</text>'
      +'</svg>'
    );
  }
  document.querySelectorAll('.abcbread img').forEach(function(img){
    var alt = img.getAttribute('alt') || 'パン';
    img.onerror = function(){ this.onerror=null; this.src=makeSVG(alt); };
    if(img.complete && img.naturalWidth===0) img.src = makeSVG(alt);
  });

  /* コースナビのアクティブ表示 */
  var navLinks = document.querySelectorAll('.abcbread__coursenav a');
  var sectionIds = ['abcbread-molds','abcbread-newbasic','abcbread-season','abcbread-basic','abcbread-richa','abcbread-richb','abcbread-richc'];
  window.addEventListener('scroll', function(){
    var cur = '';
    sectionIds.forEach(function(id){
      var el = document.getElementById(id);
      if(el && window.scrollY >= el.offsetTop - 120) cur = id;
    });
    navLinks.forEach(function(a){
      a.classList.toggle('is-active', a.getAttribute('href') === '#' + cur);
    });
  });
})();

/* ============================================
   LP コースカード ボタン位置固定
============================================ */
(function(){
  function fixLP(){
    document.querySelectorAll('.abcbread__lp-course-card').forEach(function(card){
      card.style.setProperty('display','flex','important');
      card.style.setProperty('flex-direction','column','important');
      var body = card.querySelector('.abcbread__lp-course-body');
      if(body){
        body.style.setProperty('display','flex','important');
        body.style.setProperty('flex-direction','column','important');
        body.style.setProperty('flex','1','important');
      }
      var text = card.querySelector('.abcbread__lp-course-text');
      if(text) text.style.setProperty('flex','1','important');
      var btn = card.querySelector('.abcbread__lp-course-btn');
      if(btn){
        btn.style.setProperty('margin-top','auto','important');
        btn.style.setProperty('display','block','important');
        btn.style.setProperty('flex-shrink','0','important');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', fixLP);
  window.addEventListener('load', fixLP);
})();